import { withDependencies, named } from '@wix/thunderbolt-ioc'
import type { ViewerModel, Experiments, ServiceProvider } from '@wix/thunderbolt-symbols'
import {
	ViewerModelSym,
	ExperimentsSymbol,
	SiteFeatureConfigSymbol,
	MasterPageFeatureConfigSymbol,
} from '@wix/thunderbolt-symbols'
import type {
	IEnvironmentServiceConfig,
	IEnvironmentDefinition,
	IEnvironmentService,
} from '@wix/viewer-service-environment/definition'
import { EnvironmentDefinition as definition } from '@wix/viewer-service-environment/definition'
import { EnvironmentService as impl } from '@wix/viewer-service-environment/implementations'
import type { ServiceFactoryOpts } from '@wix/services-manager/types'
import { name } from './symbols'
import type { EnvironmentServiceMasterPageConfig, EnvironmentServiceSiteConfig } from './types'
import { getServiceConfig } from './utils'

export const environmentService = withDependencies(
	[
		ViewerModelSym,
		ExperimentsSymbol,
		named(SiteFeatureConfigSymbol, name),
		named(MasterPageFeatureConfigSymbol, name),
	],
	(
		viewerModel: ViewerModel,
		experiments: Experiments,
		siteFeatureConfig: EnvironmentServiceSiteConfig,
		masterPageFeatureConfig: EnvironmentServiceMasterPageConfig
	): ServiceProvider<
			IEnvironmentDefinition,
			(opts: ServiceFactoryOpts<IEnvironmentServiceConfig>) => IEnvironmentService
		> => {
		const config = {
			...getServiceConfig(siteFeatureConfig, viewerModel),
			languageDirection: masterPageFeatureConfig.languageDirection,
			experiments,
		}

		return {
			definition,
			impl,
			config,
			platformConfig: config,
		}
	}
)
